/**
 * Products Setup API - Dataverse Product Entity
 */

import { MiddlewareAPI } from "@/lib/axios";
import { ICommonListApiRes, NetworkMethodEnum } from "@/types/common";
import { fetcher } from "@/utils/api/dataverse/fetcher";
import { mutator } from "@/utils/api/dataverse/mutator";
import { generateQueryParamsForPagination } from "@/utils/pagination";
import {
  IProduct,
  IProductForm,
  ICommonQueryParams,
} from "../types/productSetup";

export const URL = {
  products: "/ProductApi",
  productImage: "/ProductImageApi",
};

// const PRODUCT_STATUS_ACTIVE = 1;

export const createProductSetup = async (
  data: IProductForm
): Promise<IProduct> => {
  return await mutator(NetworkMethodEnum.POST, URL.products, data);
};

export const updateProductSetup = async (data: {
  id: string;
  payload: Partial<IProductForm>;
}): Promise<IProduct> => {
  const updatePayload = {
    id: data.id,
    ...data.payload,
  };
  return await mutator(NetworkMethodEnum.PATCH, URL.products, updatePayload);
};

export const changeProductStatus = async (data: {
  id: string;
  payload: { statuscode: number };
}): Promise<IProduct> => {
  const statusPayload = {
    id: data.id,
    statuscode: data.payload.statuscode,
  };

  const response = await MiddlewareAPI.patch<IProduct>(
    URL.products,
    statusPayload
  );
  return response.data;
};

export const deleteProductSetup = async (id: string): Promise<void> => {
  await MiddlewareAPI.delete(URL.products, {
    data: { id },
  });
};

export const getProductSetupList = async (
  queryParams?: ICommonQueryParams
): Promise<ICommonListApiRes<IProduct>> => {
  const query = generateQueryParamsForPagination(queryParams);
  return await fetcher(
    `${URL.products}${query}&$orderby=createdon desc`,
    queryParams?.pageSize
  );
};

export const getProductSetupDetail = async (id: string): Promise<IProduct> => {
  const response = await MiddlewareAPI.get<IProduct>(URL.products, {
    params: { id },
  });
  return response.data;
};

/**
 * Upload product image
 */
export const uploadProductImageApi = async (
  imageData: File | Blob | ArrayBuffer,
  productGuid: string,
  fileName: string,
  contentType: string = "image/png",
): Promise<any> => {
  // Convert to ArrayBuffer to send raw binary bytes without any transformation
  const buffer =
    imageData instanceof ArrayBuffer
      ? imageData
      : await (imageData as Blob).arrayBuffer();

  const response = await MiddlewareAPI.post(
    `${URL.productImage}?productGuid=${productGuid}&fileName=${fileName}`,
    buffer,
    {
      headers: {
        "Content-Type": contentType,
        // Remove OData annotation header — not applicable for binary uploads
        prefer: "",
      },
    },
  );
  return response.data;
};;
